// frontend/src/components/plot/MetricCharts.js
import React from 'react';
import StandardLineChart from './charts/StandardLineChart';
import WindChart from './charts/WindChart';
import AccumulationPhenologyChart from './charts/AccumulationPhenologyChart';
import { sortCategoryMetrics, groupAccumulationMetricsBySpecies } from './charts/chartUtils';

export { getYAxisDomain, METRIC_PANEL_ORDER, sortCategoryMetrics } from './charts/chartUtils';

export function MetricCategoryPanel({ title, categoryKey, metrics, chartData, visibleDevices, forecastVisible = true, localTimeEnabled = true }) {
  /*
  console.log(`[MetricCategoryPanel] Rendering category "${categoryKey || title}":`, {
    metrics: metrics?.map((m) => m.type || m),
    chartDataRows: chartData?.length || 0,
    sampleKeys: chartData?.[0] ? Object.keys(chartData[0]) : []
  });
  */

  if (!metrics || metrics.length === 0) return null;

  const isAccumulationCategory = categoryKey === 'crop' || String(title).toLowerCase().includes('accumulation');
  const hasWindComponents = metrics.some((m) => m.type.includes('wind_u') || m.type.includes('wind_v') || m.type === 'wind');

  const filteredMetrics = metrics.filter((m) => !m.type.includes('wind_u') && !m.type.includes('wind_v') && !m.type.includes('growth_stage'));

  return (
    <div style={{ background: '#ffffff', borderRadius: '12px', padding: '20px', border: '1px solid #e2e8f0', marginBottom: '24px' }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', color: '#0f172a', textTransform: 'capitalize' }}>
        {title}
      </h3>

      {isAccumulationCategory ? (
        groupAccumulationMetricsBySpecies(metrics).map((speciesGroup, idx) => (
          <AccumulationPhenologyChart
            key={`species-group-${idx}`}
            speciesGroup={speciesGroup}
            chartData={chartData}
            visibleDevices={visibleDevices}
            forecastVisible={forecastVisible}
            localTimeEnabled={localTimeEnabled}
          />
        ))
      ) : (
        <>
          {hasWindComponents && (
            <WindChart
              chartData={chartData}
              visibleDevices={visibleDevices}
              forecastVisible={forecastVisible}
              localTimeEnabled={localTimeEnabled}
            />
          )}

          {sortCategoryMetrics(categoryKey || title, filteredMetrics).map((m) => (
            <StandardLineChart
              key={m.type}
              metric={m}
              chartData={chartData}
              visibleDevices={visibleDevices}
              forecastVisible={forecastVisible}
              localTimeEnabled={localTimeEnabled}
            />
          ))}
        </>
      )}
    </div>
  );
}

export default MetricCategoryPanel;
